module.exports = __webpack_public_path__ + "static/media/escut-aj-matadepera-vertical.99ccfad9.svg";